import React, { Component } from 'react'
import parse from 'html-react-parser';

class Card extends Component {
constructor(props) {
super(props);
this.state = {
 }
}
render() {
    const content = parse(this.props.content)
return (
<div className="card">
    <div className="card-heading">
        <h1>{this.props.heading}</h1>
    </div>
    <div className="card-sub-heading">
        <h2>{this.props.subheading}</h2>
    </div>
    <div>
        <div className="card-content">
{content}


        </div>
        <div className="center">
            {this.props.image ? <img src={this.props.image} alt="Roaring Fork conservancy" width={this.props.width}/>:null}
            
        </div>
    </div>
</div>
);
}
}

export default Card;